import React, { useState, useEffect, useRef } from "react";
import { getAppId, getAWSUrl } from "../api/core";
import Global, { FLOAT } from "../../global";
import { Link } from "react-router-dom";
import Anchor from "../Link/anchor";
import InPlayer from "../backend/inplayer";
import { useHistory } from "react-router-dom";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { clearOut } from "../login/logout";
import { DarkModeStore } from "../store/darkModeStore";
import {
  getSetting,
  intializeSetting,
  isEmpty,
  saveSetting,
  setSetting,
} from "../javascript/function";

const Header = (props) => {
  const [show, SetShow] = useState(false);
  const [showMobile, SetShowMobile] = useState(false);
  const [scrolled, setScrolled] = React.useState(false);
  const [menuSchema, setMenu] = useState([]);
  const theme = DarkModeStore.useState((s) => s.themeMode);
  const [themeType, setTheme] = useState(theme);
  const [branding, setBranding] = useState(
    localStorage.getItem("prev_logo") ? localStorage.getItem("prev_logo") : ""
  );
  const node = useRef();
  const [userMenu, SetUserMenu] = useState(false);
  const [lastMenu, setLastMenu] = useState([]);
  const [fullMenu, setFullMenu] = useState([]);
  const [search, SetSearch] = useState(false);
  const [searchText, setSearchText] = useState(
    props.match.params.pageType === "search" ? props.match.params.searchId : ""
  );
  const mounted = useRef(false);
  let history = useHistory();
  //const [loading, setLoading] = useState(false);

  const Logout = (event) => {
    event.preventDefault();
    toastr.info("Logging Out", "Please Wait..");
    InPlayer.Account.signOut()
      .then((data) => {
        toastr.clear();
        clearOut();
        if (Global.LOGIN && Global.SUBSCRIPTION) {
          let path = "/" + props.match.params.AppId + "/welcome";
          history.push(path);
        } else if (!Global.LOGIN && Global.SUBSCRIPTION) {
          let path = "/" + props.match.params.AppId + "/home";
          history.push(path);
        } else if (Global.LOGIN && !Global.SUBSCRIPTION) {
          let path = "/" + props.match.params.AppId + "/welcome";
          history.push(path);
        } else {
          let path = "/" + props.match.params.AppId + "/home";
          history.push(path);
        }
      })
      .catch((error) => {
        toastr.error("Logout Failed", "Error");
      });
  };
  const moreMenu = (event) => {
    event.preventDefault();
    SetShow(!show);
    if (showMobile) {
      SetShowMobile(false);
    }
  };
  const mobileNav = (event) => {
    event.preventDefault();
    SetShowMobile(!showMobile);
    if (show) {
      SetShow(false);
    }
  };

  const changeThemeMode = (event) => {
    event.preventDefault();
    DarkModeStore.update((s) => {
      s.themeMode = !themeType;
    });
    setTheme(!themeType);
    let settings = getSetting();
    if (!isEmpty(settings)) {
      settings.DARK_MODE = !themeType;
      setSetting(settings);
      saveSetting(settings);
    } else {
      settings = intializeSetting();
      settings.DARK_MODE = !themeType;
      setSetting(settings);
      saveSetting(settings);
    }
  };

  const userNav = (event) => {
    event.preventDefault();
    SetUserMenu(!userMenu);
  };
  const handleSearch = (event) => {
    event.preventDefault();
    SetSearch(!search);
  };
  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 200) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  const handleChange = (event) => {
    setSearchText(event.target.value);
    if (
      props.match.params.pageType !== "search" &&
      !props.match.params.searchId
    ) {
      let path =
        "/" + props.match.params.AppId + "/search/" + event.target.value;
      history.push(path);
    } else if (
      props.match.params.pageType === "search" &&
      !props.match.params.searchId
    ) {
      let path =
        "/" + props.match.params.AppId + "/search/" + event.target.value;
      history.push(path);
    }
  };

  const clearSearch = (event) => {
    setSearchText("");
    if (
      props.match.params.pageType !== "search" &&
      !props.match.params.searchId
    ) {
      let path = "/" + props.match.params.AppId + "/search/";
      history.push(path);
    } else if (
      props.match.params.pageType === "search" &&
      !props.match.params.searchId
    ) {
      let path = "/" + props.match.params.AppId + "/search/";
      history.push(path);
    }
  };

  const handleClick = (e) => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    SetShow(false);
    SetShowMobile(false);
    SetUserMenu(false);
  };
  const handlePush = () => {
    SetShowMobile(false);
  };

  const changeDisplay = (event, _id, index) => {
    const ul = document.getElementById(_id);
    const li = document.getElementById(_id + index);
    const child = li.firstElementChild;
    if (ul.classList.contains("no-display")) {
      ul.classList.remove("no-display");
      child.classList.remove("fa-angle-down");
      child.classList.add("fa-angle-right");
    } else {
      ul.classList.add("no-display");
      child.classList.add("fa-angle-down");
      child.classList.remove("fa-angle-right");
    }
  };
  useEffect(() => {
    mounted.current = true;

    // return function to be called when unmounted

    if (mounted.current) {
      window.addEventListener("scroll", handleScroll);

      // add when mounted
      document.addEventListener("mousedown", handleClick);
      setBranding(props.branding);
      let firArr = props.data;
      setFullMenu(firArr);
      let newArray = firArr.sort(({ menuOrder: a }, { menuOrder: b }) => a - b);

      let fnewArray = newArray.filter(function (el, index) {
        return index < Global.Menu;
      });
      let lnewArray = newArray.filter(function (el, index) {
        return index >= Global.Menu;
      });

      setMenu(fnewArray);
      setLastMenu(lnewArray);
    }
    return () => {
      document.removeEventListener("mousedown", handleClick);
      mounted.current = false;
    };
  }, [props.branding, props.data]);

  return (
    <header id="main-header" className={scrolled ? "scrolled" : ""} ref={node}>
      <div className="main-header">
        <div className="container-fluid pad-left">
          <div className="row">
            <div className="col-sm-12">
              <nav className="navbar navbar-expand-lg navbar-light p-0">
                <a
                  href="#!"
                  className="navbar-toggler c-toggler"
                  data-toggle="collapse"
                  data-target="#navbarSupportedContent"
                  aria-controls="navbarSupportedContent"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <div
                    className="navbar-toggler-icon"
                    data-toggle="collapse"
                    onClick={mobileNav}
                  >
                    <span className="navbar-menu-icon navbar-menu-icon--top bar" />
                    <span className="navbar-menu-icon navbar-menu-icon--middle bar" />
                    <span className="navbar-menu-icon navbar-menu-icon--bottom bar" />
                  </div>
                </a>
                <a
                  className="navbar-brand"
                  href={"/" + props.match.params.AppId + "/home"}
                >
                  {" "}
                  <img
                    className="img-fluid logo"
                    src={getAWSUrl() + branding}
                    alt="SMOTT"
                  />{" "}
                </a>
                <div
                  className={"collapse navbar-collapse"}
                  id="navbarSupportedContent"
                >
                  <div className="menu-main-menu-container">
                    <ul
                      id="top-menu"
                      className={
                        FLOAT === "left"
                          ? "navbar-nav ml-auto float-left"
                          : FLOAT === "right"
                          ? "navbar-nav ml-auto float-right"
                          : "navbar-nav ml-auto"
                      }
                    >
                      {menuSchema.map((person, index) =>
                        person.menuType !== "multiple" ? (
                          <li className="menu-item" key={index}>
                            <Anchor
                              className={
                                props.match.url ===
                                  "/" +
                                    props.match.params.AppId +
                                    "/" +
                                    person.urlName ||
                                props.match.url ===
                                  "/" +
                                    props.match.params.AppId +
                                    "/page/" +
                                    person.menuPage
                                  ? "active"
                                  : props.match.url ===
                                      "/" + props.match.params.AppId &&
                                    person.urlName === "home"
                                  ? "active"
                                  : ""
                              }
                              to={
                                "/" +
                                props.match.params.AppId +
                                "/" +
                                person.urlName
                              }
                            >
                              {person.menuTitle}
                            </Anchor>
                          </li>
                        ) : person.items !== null ? (
                          person.items.length > 0 ? (
                            <li className="menu-item" key={index}>
                              <a href="#!">
                                {person.menuTitle}{" "}
                                <i className="ri-arrow-down-s-line"></i>
                              </a>
                              <ul className="sub-menu">
                                {person.items.map((item, index) => (
                                  <li key={item._id} className="menu-item">
                                    <Anchor
                                      className={
                                        props.match.url ===
                                          "/" +
                                            props.match.params.AppId +
                                            "/" +
                                            item.menuUrlName ||
                                        props.match.url ===
                                          "/" +
                                            props.match.params.AppId +
                                            "/page/" +
                                            item.menuPage
                                          ? "active"
                                          : props.match.url ===
                                              "/" + props.match.params.AppId &&
                                            item.menuUrlName === "home"
                                          ? "active"
                                          : ""
                                      }
                                      to={
                                        "/" +
                                        props.match.params.AppId +
                                        "/" +
                                        item.menuUrlName
                                      }
                                    >
                                      {item.menuTitle}
                                    </Anchor>
                                  </li>
                                ))}
                              </ul>
                            </li>
                          ) : (
                            <li className="menu-item" key={index}>
                              <Anchor
                                className={
                                  props.match.url ===
                                    "/" +
                                      props.match.params.AppId +
                                      "/" +
                                      person.urlName ||
                                  props.match.url ===
                                    "/" +
                                      props.match.params.AppId +
                                      "/page/" +
                                      person.menuPage
                                    ? "active"
                                    : props.match.url ===
                                        "/" + props.match.params.AppId &&
                                      person.urlName === "home"
                                    ? "active"
                                    : ""
                                }
                                to={
                                  "/" +
                                  props.match.params.AppId +
                                  "/" +
                                  person.urlName
                                }
                              >
                                {person.menuTitle}
                              </Anchor>
                            </li>
                          )
                        ) : (
                          <li className="menu-item" key={index}>
                            <Anchor
                              className={
                                props.match.url ===
                                  "/" +
                                    props.match.params.AppId +
                                    "/" +
                                    person.urlName ||
                                props.match.url ===
                                  "/" +
                                    props.match.params.AppId +
                                    "/page/" +
                                    person.menuPage
                                  ? "active"
                                  : props.match.url ===
                                      "/" + props.match.params.AppId &&
                                    person.urlName === "home"
                                  ? "active"
                                  : ""
                              }
                              to={
                                "/" +
                                props.match.params.AppId +
                                "/" +
                                person.urlName
                              }
                            >
                              {person.menuTitle}
                            </Anchor>
                          </li>
                        )
                      )}

                      {lastMenu.length > 0 ? (
                        <li className="menu-item" key={"more456menu#123"}>
                          <a href="#!">
                            More <i className="ri-arrow-down-s-line"></i>
                          </a>
                          <ul className="sub-menu">
                            {lastMenu.map((person, index) =>
                              person.menuType !== "multiple" ? (
                                <li key={index} className="menu-item">
                                  <Anchor
                                    className={
                                      props.match.url ===
                                        "/" +
                                          props.match.params.AppId +
                                          "/" +
                                          person.urlName ||
                                      props.match.url ===
                                        "/" +
                                          props.match.params.AppId +
                                          "/page/" +
                                          person.menuPage
                                        ? "active"
                                        : props.match.url ===
                                            "/" + props.match.params.AppId &&
                                          person.urlName === "home"
                                        ? "active"
                                        : ""
                                    }
                                    to={
                                      "/" +
                                      props.match.params.AppId +
                                      "/" +
                                      person.urlName
                                    }
                                  >
                                    {person.menuTitle}
                                  </Anchor>
                                </li>
                              ) : person.items !== null ? (
                                person.items.length > 0 ? (
                                  <li key={index} className="menu-item">
                                    <a href="#!">
                                      {person.menuTitle}{" "}
                                      <i className="ri-arrow-right-s-line"></i>
                                    </a>
                                    <ul className="dropdown-sub-menu">
                                      {person.items.map((item, index) => (
                                        <li
                                          key={item._id}
                                          className="menu-item"
                                        >
                                          <Anchor
                                            className={
                                              props.match.url ===
                                                "/" +
                                                  props.match.params.AppId +
                                                  "/" +
                                                  item.menuUrlName ||
                                              props.match.url ===
                                                "/" +
                                                  props.match.params.AppId +
                                                  "/page/" +
                                                  item.menuPage
                                                ? "active"
                                                : props.match.url ===
                                                    "/" +
                                                      props.match.params
                                                        .AppId &&
                                                  item.menuUrlName === "home"
                                                ? "active"
                                                : ""
                                            }
                                            to={
                                              "/" +
                                              props.match.params.AppId +
                                              "/" +
                                              item.menuUrlName
                                            }
                                          >
                                            {item.menuTitle}
                                          </Anchor>
                                        </li>
                                      ))}
                                    </ul>
                                  </li>
                                ) : (
                                  <li key={index} className="menu-item">
                                    <Anchor
                                      className={
                                        props.match.url ===
                                          "/" +
                                            props.match.params.AppId +
                                            "/" +
                                            person.urlName ||
                                        props.match.url ===
                                          "/" +
                                            props.match.params.AppId +
                                            "/page/" +
                                            person.menuPage
                                          ? "active"
                                          : props.match.url ===
                                              "/" + props.match.params.AppId &&
                                            person.urlName === "home"
                                          ? "active"
                                          : ""
                                      }
                                      to={
                                        "/" +
                                        props.match.params.AppId +
                                        "/" +
                                        person.urlName
                                      }
                                    >
                                      {person.menuTitle}
                                    </Anchor>
                                  </li>
                                )
                              ) : (
                                <li key={index} className="menu-item">
                                  <Anchor
                                    className={
                                      props.match.url ===
                                        "/" +
                                          props.match.params.AppId +
                                          "/" +
                                          person.urlName ||
                                      props.match.url ===
                                        "/" +
                                          props.match.params.AppId +
                                          "/page/" +
                                          person.menuPage
                                        ? "active"
                                        : props.match.url ===
                                            "/" + props.match.params.AppId &&
                                          person.urlName === "home"
                                        ? "active"
                                        : ""
                                    }
                                    to={
                                      "/" +
                                      props.match.params.AppId +
                                      "/" +
                                      person.urlName
                                    }
                                  >
                                    {person.menuTitle}
                                  </Anchor>
                                </li>
                              )
                            )}
                          </ul>
                        </li>
                      ) : (
                        ""
                      )}
                    </ul>
                  </div>
                </div>

                <div
                  className={`mobile-menu ${showMobile ? "no-transform" : ""}`}
                >
                  <div className="menu-content">
                    <div className="menu-content-header">
                      <div className="menu-content-logo">
                        <div className="menu-content-site-branding">
                          <a
                            className="menu-content-light-logo"
                            href={"/" + getAppId() + "/"}
                          >
                            <img
                              width={162}
                              height={52}
                              src={getAWSUrl() + branding}
                              alt="smott"
                            />
                          </a>
                        </div>
                      </div>
                      <div className="close-btn menu-close" onClick={mobileNav}>
                        <a href="#!">
                          <i className="fa fa-times" />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="menu-middle">
                    <ul>
                      {fullMenu.map((person, index) =>
                        person.menuType !== "multiple" ? (
                          <li key={index}>
                            <Anchor
                              className={
                                props.match.url ===
                                  "/" +
                                    props.match.params.AppId +
                                    "/" +
                                    person.urlName ||
                                props.match.url ===
                                  "/" +
                                    props.match.params.AppId +
                                    "/page/" +
                                    person.menuPage
                                  ? "active"
                                  : props.match.url ===
                                      "/" + props.match.params.AppId &&
                                    person.urlName === "home"
                                  ? "active"
                                  : ""
                              }
                              to={
                                "/" +
                                props.match.params.AppId +
                                "/" +
                                person.urlName
                              }
                              onClick={handlePush}
                            >
                              {person.menuTitle}
                            </Anchor>
                          </li>
                        ) : person.items !== null && person.items.length > 0 ? (
                          <li
                            key={index}
                            className="sub-list"
                            onClick={(event) => {
                              event.preventDefault();
                              changeDisplay(event, person._id, index);
                            }}
                          >
                            <Link to="#!" id={person._id + index}>
                              {person.menuTitle}{" "}
                              <i className="fa fa-angle-down" />
                            </Link>
                            <ul className="no-display" id={person._id}>
                              {person.items.map((item, index) => (
                                <li key={index}>
                                  <Anchor
                                    className={
                                      props.match.url ===
                                        "/" +
                                          props.match.params.AppId +
                                          "/" +
                                          item.menuUrlName ||
                                      props.match.url ===
                                        "/" +
                                          props.match.params.AppId +
                                          "/page/" +
                                          item.menuPage
                                        ? "active"
                                        : props.match.url ===
                                            "/" + props.match.params.AppId &&
                                          item.menuUrlName === "home"
                                        ? "active"
                                        : ""
                                    }
                                    to={
                                      "/" +
                                      props.match.params.AppId +
                                      "/" +
                                      item.menuUrlName
                                    }
                                    onClick={handlePush}
                                  >
                                    {item.menuTitle}
                                  </Anchor>
                                </li>
                              ))}
                            </ul>
                          </li>
                        ) : (
                          <li key={index} className="sub-list">
                            <Link
                              to="#!"
                              onClick={(event) => {
                                event.preventDefault();
                              }}
                            >
                              {person.menuTitle}{" "}
                              <i className="fa fa-angle-down" />
                            </Link>
                          </li>
                        )
                      )}
                    </ul>
                  </div>
                </div>
                <div className={`mobile-more-menu`}>
                  <a
                    href="#!"
                    className="more-toggle"
                    id="dropdownMenuButton"
                    data-toggle="more-toggle"
                    aria-expanded="false"
                    onClick={moreMenu}
                  >
                    <i className="ri-more-line" />
                  </a>
                  <div
                    className={`more-menu ${show ? "show" : ""}`}
                    aria-labelledby="dropdownMenuButton"
                  >
                    <div className="navbar-right position-relative">
                      <ul className="d-flex align-items-center justify-content-end list-inline m-0">
                        <li className={search ? "iq-show" : ""}>
                          <Link
                            to="#!"
                            className="search-toggle"
                            onClick={handleSearch}
                          >
                            <i className="ri-search-line" />
                          </Link>
                          <div className="search-box iq-search-bar">
                            <form action="#" className="searchbox">
                              <div className="form-group position-relative">
                                <input
                                  type="text"
                                  className="text search-input font-size-12"
                                  placeholder="Search Here..."
                                  onChange={handleChange}
                                  value={searchText}
                                />
                                <i className="search-link ri-search-line" />
                                <div
                                  className="Search_Button Search_Wrap"
                                  aria-label="Clear search"
                                  role="button"
                                  tabIndex="0"
                                  onClick={clearSearch}
                                >
                                  <svg
                                    className="Search_SVG"
                                    viewBox="0 0 18 18"
                                    focusable="false"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g>
                                      <path d="M9 1C4.58 1 1 4.58 1 9s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm4 10.87L11.87 13 9 10.13 6.13 13 5 11.87 7.87 9 5 6.13 6.13 5 9 7.87 11.87 5 13 6.13 10.13 9 13 11.87z"></path>
                                    </g>
                                  </svg>
                                </div>
                              </div>
                            </form>
                          </div>
                        </li>
                        {Global.DARK_MODE ? (
                          <li className="nav-item nav-icon">
                            <Link
                              to="#!"
                              className="search-toggle"
                              onClick={changeThemeMode}
                            >
                              <i
                                className={
                                  props.theme ? "ri-moon-line" : "ri-moon-fill"
                                }
                              />
                            </Link>
                          </li>
                        ) : (
                          ""
                        )}
                        <li
                          className={
                            !Global.SUBSCRIPTION && !Global.LOGIN
                              ? "invisible"
                              : userMenu
                              ? "iq-show"
                              : ""
                          }
                        >
                          <a
                            href="#!"
                            className={
                              userMenu
                                ? "iq-user-dropdown search-toggle p-0 d-flex align-items-center newPrime active"
                                : "iq-user-dropdown search-toggle p-0 d-flex align-items-center newPrime"
                            }
                            onClick={userNav}
                            onMouseEnter={() => {
                              SetUserMenu(true);
                            }}
                          >
                            <i className="fa fa-user-circle primeBackground"></i>
                          </a>
                          <div
                            className="iq-sub-dropdown iq-user-dropdown"
                            onMouseLeave={() => {
                              SetUserMenu(false);
                            }}
                          >
                            <div className="iq-card shadow-none m-0">
                              <div className="iq-card-body p-0 pl-3 pr-3">
                                <Link
                                  to={
                                    "/" + props.match.params.AppId + "/profile"
                                  }
                                  className="iq-sub-card setting-dropdown"
                                >
                                  <div className="media align-items-center">
                                    <div className="right-icon">
                                      <i className="ri-file-user-line text-primary" />
                                    </div>
                                    <div className="media-body ml-3">
                                      <h6 className="mb-0 ">
                                        Profile & Settings
                                      </h6>
                                    </div>
                                  </div>
                                </Link>

                                {Global.FAVOURITES ? (
                                  <Link
                                    to={
                                      "/" +
                                      props.match.params.AppId +
                                      "/favourites"
                                    }
                                    className="iq-sub-card setting-dropdown"
                                  >
                                    <div className="media align-items-center">
                                      <div className="right-icon">
                                        <i className="ri-heart-2-fill text-primary" />
                                      </div>
                                      <div className="media-body ml-3">
                                        <h6 className="mb-0 ">Favourites</h6>
                                      </div>
                                    </div>
                                  </Link>
                                ) : (
                                  ""
                                )}

                                {Global.WATCHHISTORY ? (
                                  <Link
                                    to={
                                      "/" +
                                      props.match.params.AppId +
                                      "/watchhistory"
                                    }
                                    className="iq-sub-card setting-dropdown"
                                  >
                                    <div className="media align-items-center">
                                      <div className="right-icon">
                                        <i className="ri-file-fill text-primary" />
                                      </div>
                                      <div className="media-body ml-3">
                                        <h6 className="mb-0 ">Watch History</h6>
                                      </div>
                                    </div>
                                  </Link>
                                ) : (
                                  ""
                                )}

                                <Link
                                  to="#!"
                                  className="iq-sub-card setting-dropdown"
                                  onClick={Logout}
                                >
                                  <div className="media align-items-center">
                                    <div className="right-icon">
                                      <i className="ri-logout-circle-line text-primary" />
                                    </div>
                                    <div className="media-body ml-3">
                                      <h6 className="mb-0">Logout</h6>
                                    </div>
                                  </div>
                                </Link>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="navbar-right menu-right">
                  <ul className="d-flex align-items-center list-inline m-0">
                    <li
                      className={
                        !search
                          ? "nav-item nav-icon"
                          : "nav-item nav-icon iq-show"
                      }
                    >
                      <a
                        href="#!"
                        className="search-toggle device-search"
                        onClick={handleSearch}
                      >
                        <i className="ri-search-line" />
                      </a>
                      <div className="search-box iq-search-bar d-search">
                        <form action="#" className="searchbox">
                          <div className="form-group position-relative">
                            <input
                              type="text"
                              className="text search-input font-size-12"
                              placeholder="Search..."
                              onChange={handleChange}
                              value={searchText}
                            />
                            <i className="search-link ri-search-line" />
                            <div
                              className="Search_Button Search_Wrap"
                              aria-label="Clear search"
                              role="button"
                              tabIndex="0"
                              onClick={clearSearch}
                            >
                              <svg
                                className="Search_SVG"
                                viewBox="0 0 18 18"
                                focusable="false"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <g>
                                  <path d="M9 1C4.58 1 1 4.58 1 9s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm4 10.87L11.87 13 9 10.13 6.13 13 5 11.87 7.87 9 5 6.13 6.13 5 9 7.87 11.87 5 13 6.13 10.13 9 13 11.87z"></path>
                                </g>
                              </svg>
                            </div>
                          </div>
                        </form>
                      </div>
                    </li>

                    {Global.DARK_MODE ? (
                      <li className="nav-item nav-icon">
                        <Link
                          to="#!"
                          className="search-toggle"
                          onClick={changeThemeMode}
                        >
                          <i
                            className={
                              props.theme ? "ri-moon-line" : "ri-moon-fill"
                            }
                          />
                          <span className="tooltiptext">
                            {props.theme
                              ? "Enable Light Mode"
                              : "Enable Dark Mode"}
                          </span>
                        </Link>
                      </li>
                    ) : (
                      ""
                    )}
                    {/* <li className="nav-item nav-icon">
                      <a href="#!" className="search-toggle" data-toggle="search-toggle">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={22} height={22} className="noti-svg">
                          <path fill="none" d="M0 0h24v24H0z" />
                          <path d="M18 10a6 6 0 1 0-12 0v8h12v-8zm2 8.667l.4.533a.5.5 0 0 1-.4.8H4a.5.5 0 0 1-.4-.8l.4-.533V10a8 8 0 1 1 16 0v8.667zM9.5 21h5a2.5 2.5 0 1 1-5 0z" />
                        </svg>
                        <span className="bg-danger dots" />
                      </a>
                      <div className="iq-sub-dropdown">
                        <div className="iq-card shadow-none m-0">
                          <div className="iq-card-body">
                            <a href="#!" className="iq-sub-card">
                              <div className="media align-items-center">
                                <img src="images/notify/thumb-1.jpg" className="img-fluid mr-3" alt="streamit" />
                                <div className="media-body">
                                  <h6 className="mb-0 ">Boot Bitty</h6>
                                  <small className="font-size-12"> just now</small>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="iq-sub-card">
                              <div className="media align-items-center">
                                <img src="images/notify/thumb-2.jpg" className="img-fluid mr-3" alt="streamit" />
                                <div className="media-body">
                                  <h6 className="mb-0 ">The Last Breath</h6>
                                  <small className="font-size-12">15 minutes ago</small>
                                </div>
                              </div>
                            </a>
                            <a href="#!" className="iq-sub-card">
                              <div className="media align-items-center">
                                <img src="images/notify/thumb-3.jpg" className="img-fluid mr-3" alt="streamit" />
                                <div className="media-body">
                                  <h6 className="mb-0 ">The Hero Camp</h6>
                                  <small className="font-size-12">1 hour ago</small>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      </div>
                    </li> */}
                    <li
                      className={
                        !Global.SUBSCRIPTION && !Global.LOGIN
                          ? "invisible"
                          : userMenu
                          ? "nav-item nav-icon iq-show"
                          : "nav-item nav-icon"
                      }
                    >
                      <a
                        href="#!"
                        className={
                          userMenu
                            ? "iq-user-dropdown search-toggle p-0 d-flex align-items-center newPrime active"
                            : "iq-user-dropdown search-toggle p-0 d-flex align-items-center newPrime"
                        }
                        data-toggle="search-toggle"
                        onClick={userNav}
                        onMouseEnter={() => {
                          SetUserMenu(true);
                        }}
                      >
                        <i className="fa fa-user-circle primeBackground"></i>
                      </a>
                      <div
                        className="iq-sub-dropdown iq-user-dropdown"
                        onMouseLeave={() => {
                          SetUserMenu(false);
                        }}
                      >
                        <div className="iq-card shadow-none m-0">
                          <div className="iq-card-body p-0 pl-3 pr-3">
                            <Link
                              to={"/" + props.match.params.AppId + "/profile"}
                              className="iq-sub-card setting-dropdown"
                            >
                              <div className="media align-items-center">
                                <div className="right-icon">
                                  <i className="ri-file-user-line text-primary" />
                                </div>
                                <div className="media-body ml-3">
                                  <h6 className="mb-0 ">Profile & Settings</h6>
                                </div>
                              </div>
                            </Link>

                            {Global.FAVOURITES ? (
                              <Link
                                to={
                                  "/" + props.match.params.AppId + "/favourites"
                                }
                                className="iq-sub-card setting-dropdown"
                              >
                                <div className="media align-items-center">
                                  <div className="right-icon">
                                    <i className="ri-heart-2-fill text-primary" />
                                  </div>
                                  <div className="media-body ml-3">
                                    <h6 className="mb-0 ">Favourites</h6>
                                  </div>
                                </div>
                              </Link>
                            ) : (
                              ""
                            )}

                            {Global.WATCHHISTORY ? (
                              <Link
                                to={
                                  "/" +
                                  props.match.params.AppId +
                                  "/watchhistory"
                                }
                                className="iq-sub-card setting-dropdown"
                              >
                                <div className="media align-items-center">
                                  <div className="right-icon">
                                    <i className="ri-file-fill text-primary" />
                                  </div>
                                  <div className="media-body ml-3">
                                    <h6 className="mb-0 ">Watch History</h6>
                                  </div>
                                </div>
                              </Link>
                            ) : (
                              ""
                            )}

                            <Link
                              to="#!"
                              className="iq-sub-card setting-dropdown"
                              onClick={Logout}
                            >
                              <div className="media align-items-center">
                                <div className="right-icon">
                                  <i className="ri-logout-circle-line text-primary" />
                                </div>
                                <div className="media-body ml-3">
                                  <h6 className="mb-0 ">Logout</h6>
                                </div>
                              </div>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </nav>
              <div className="nav-overlay" />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
